module.exports = __webpack_public_path__ + "static/media/main-1.be90d504.png";